import { ApiBase } from '../api-base'

export class EmployeeServices extends ApiBase {
  constructor() {
    super({
      resource: '/api/v1/employees',
      name: 'employee',
      successPath: '/employees'
    })
  }

  /**
   * @param {Object} params
   * @param {String} params.search
   * @param {String} params.by_accredited
   * @param {Integer} params.by_role_id
   * @param {Integer} params.page
   * @returns {Promise}
   *
   */
  index({ page, order = 'DESC', q, byRoleId, byContract, byAccredited }) {
    const params = {
      order
    }

    if (q) {
      params.search = q
    }

    if (byAccredited) {
      params.by_accredited = byAccredited
    }

    if (byRoleId) {
      params.by_role_id = byRoleId
    }

    if (byContract) {
      params.by_associated_contract = byContract
    }

    if (page) {
      params.page = page
    }

    return this.api.get(`${this.resource}`, new URLSearchParams(params))
  }

  getAttachmentTypes() {
    return this.api.get(`${this.resource}/attachment_types`)
  }

  getRoles() {
    return this.api.get(`${this.resource}/roles`)
  }

  getContractorContractsIds() {
    return this.api.get(`${this.resource}/contractor_contracts_ids`)
  }
}
